import React from "react";
import DOMPurify from "dompurify";
import { renderQuillDeltaToHtml } from "../../../utils/quill/quill-delta-to-html";
import { normalizeQuillListHtml } from "../../../utils/quill/normalize-quill-list-html";
import { filterClass } from "../../../utils/class-utils";
import { serializedHtmlContainsTables } from "./content";
import type { QuillTextProps } from "../types";

export function QuillText(props: QuillTextProps) {
  const { delta, paddingClass = "py-0", className } = props;

  // Parse as new format {delta, html}
  let html = "";
  if (delta) {
    try {
      const parsed = JSON.parse(delta);
      if (parsed && typeof parsed === "object") {
        const parsedHtml = typeof parsed.html === "string" ? normalizeQuillListHtml(parsed.html) : "";
        const renderedDeltaHtml = parsed.delta
          ? renderQuillDeltaToHtml(JSON.stringify(parsed.delta))
          : "";

        html = serializedHtmlContainsTables(parsedHtml)
          ? parsedHtml
          : renderedDeltaHtml || parsedHtml;
      }
    } catch {
      // Not valid JSON, no legacy support
      html = "";
    }
  }

  const resolvedClassName = ["eb-QuillText", filterClass(paddingClass), className].filter(Boolean).join(" ");

  const sanitizedHtml = html ? DOMPurify.sanitize(html) : "";

  return (
    <div
      className={resolvedClassName || undefined}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
}

export default QuillText;
